import React from 'react';
import { View } from 'react-native';

export const Camera = React.forwardRef((_props: any, _ref: any) => {
  return React.createElement(View, null);
});

Camera.displayName = 'Camera';

export function useCameraDevice(_type: string) {
  return null;
}

export function useCameraPermission() {
  return {
    hasPermission: false,
    requestPermission: async () => false,
  };
}
